import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';

import {Menu} from 'semantic-ui-react';

class RedditMenu extends Component {

    shouldComponentUpdate({location: {
            pathname
        }}) {
        return pathname !== this.props.location.pathname;
    }

    render() {
        const {route} = this.props;
        return <Menu.Menu>
            <Menu.Item as={NavLink} exact={true} to={route} icon="reddit"/>
        </Menu.Menu>;
    }
}

const connectedMenu = connect(({routes: {
        clientReddit
    }}) => ({route: clientReddit}))(RedditMenu);
export default withRouter(connectedMenu);


// WEBPACK FOOTER //
// ./src/apps/client-reddit/components/Menu.js